import MDatatable from "./MDatatable.vue";
export default MDatatable